(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    class Accordion {
    constructor(container) {
      this.container = container
      this.buttons = container.querySelectorAll('[data-accordion-button]')
      this.panels = container.querySelectorAll('[data-accordion-panel]')
      this.init()
    }

    init() {
      this.buttons.forEach(button => {
        button.addEventListener('click', () => this.toggle(button))
      })

      requestAnimationFrame(() => {
        const openPanel = this.container.querySelector('.accordion-item__content--active')
        if (openPanel) {
          openPanel.style.maxHeight = openPanel.scrollHeight + 'px'
        }
      })
    }

    toggle(button) {
      const isActive = button.classList.contains('accordion-item__trigger--active')
      const panelId = button.dataset.accordionButton
      const panel = this.container.querySelector(`[data-accordion-panel="${panelId}"]`)

      this.buttons.forEach(btn => {
        btn.classList.remove('accordion-item__trigger--active')
        btn.setAttribute('aria-expanded', 'false')
      })
      this.panels.forEach(pnl => {
        pnl.classList.remove('accordion-item__content--active')
        pnl.style.maxHeight = '0px'
      })

      if (!isActive) {
        button.classList.add('accordion-item__trigger--active')
        button.setAttribute('aria-expanded', 'true')
        panel.classList.add('accordion-item__content--active')
        requestAnimationFrame(() => {
          panel.style.maxHeight = panel.scrollHeight + 'px'
        })
      }
    }
  }

  document.querySelectorAll('[data-accordion]').forEach(el => {
    new Accordion(el)
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["menu"] && !Shopify.designMode) return;
  try {
    class MenuAccordion {
    constructor(menu) {
      this.menu = menu
      this.collapse = menu.dataset.collapse
      this.trigger = menu.querySelector('[data-menu-trigger]')
      this.panel = menu.querySelector('[data-menu-panel]')
      if (!this.trigger || !this.panel) return
      this.open = this.trigger.classList.contains('menu__trigger--open')
      this.resizeTimer = null

      this.trigger.addEventListener('click', () => this.toggle())
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer)
        this.resizeTimer = setTimeout(() => this.applyState(), 150)
      })

      this.applyState()
    }

    isActive() {
      if (this.collapse === 'menu--accordion') return true
      if (this.collapse === 'menu--accordion-mobile') return window.matchMedia('(max-width: 767px)').matches
      if (this.collapse === 'menu--accordion-desktop') return window.matchMedia('(min-width: 768px)').matches
      return false
    }

    applyState() {
      const active = this.isActive()
      this.menu.classList.toggle('menu--accordion-active', active)

      if (!active) {
        this.panel.style.maxHeight = ''
        this.trigger.setAttribute('aria-expanded', 'true')
        return
      }

      this.trigger.classList.toggle('menu__trigger--open', this.open)
      this.trigger.setAttribute('aria-expanded', this.open ? 'true' : 'false')
      this.panel.style.maxHeight = this.open ? this.panel.scrollHeight + 'px' : '0px'
    }

    toggle() {
      this.open = !this.open
      this.applyState()
    }
  }

  document.querySelectorAll('[data-menu]').forEach((el) => {
    if (el.dataset.collapse && el.dataset.collapse !== 'menu--list') {
      new MenuAccordion(el)
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-buttons"] && !Shopify.designMode) return;
  try {
    class ProductForm {
    constructor(container) {
      this.container = container
      this.form = container.querySelector('form')
      this.atcButton = container.querySelector('[data-add-to-cart]')
      this.atcText = container.querySelector('.product-buttons__atc-text')
      this.atcAdded = container.querySelector('.product-buttons__atc-added')
      this.variantInput = container.querySelector('input[name="id"]')
      this.loadingText = container.dataset.loadingText
      this.addToCartText = container.dataset.addToCartText
      this.soldOutText = container.dataset.soldOutText
      
      if (this.form) {
        this.init()
      }
    }

    init() {
      this.form.addEventListener('submit', (e) => this.handleSubmit(e))
      
      document.addEventListener('variant:change', (e) => {
        this.updateVariant(e.detail.variant)
      })
    }

    async handleSubmit(e) {
      e.preventDefault()
      
      this.atcButton.disabled = true
      this.atcText.textContent = this.loadingText
      
      const formData = new FormData(this.form)
      const cartType = window.CartUtils ? window.CartUtils.getCartType() : 'page'
      
      try {
        const result = await window.CartUtils.addItem(formData)
        
        if (result.success) {
          this.showAdded()
          
          if (cartType === 'page') {
            window.location = '/cart'
          }
        } else {
          throw new Error(result.error || 'Failed to add to cart')
        }
      } catch (error) {
        console.error('Error adding to cart:', error)
        this.atcText.textContent = this.addToCartText
        this.atcButton.disabled = false
      }
    }

    showAdded() {
      this.atcButton.classList.add('is-added')
      this.atcAdded.hidden = false
      
      setTimeout(() => {
        this.atcButton.classList.remove('is-added')
        this.atcAdded.hidden = true
        this.atcText.textContent = this.addToCartText
        this.atcButton.disabled = false
      }, 2000)
    }

    updateVariant(variant) {
      if (!variant) return
      
      this.variantInput.value = variant.id
      
      if (variant.available) {
        this.atcButton.disabled = false
        this.atcText.textContent = this.addToCartText
      } else {
        this.atcButton.disabled = true
        this.atcText.textContent = this.soldOutText
      }
    }
  }

  document.querySelectorAll('[data-product-form]').forEach(form => {
    new ProductForm(form)
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["recipe-featured-product"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.recipe-featured-product__form').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      const button = form.querySelector('[data-add-to-cart]');
      const formData = new FormData(form);
      const cartType = window.CartUtils ? window.CartUtils.getCartType() : 'page';

      button.disabled = true;
      button.textContent = 'Adding...';

      try {
        const result = await window.CartUtils.addItem(formData);

        if (result.success) {
          button.textContent = 'Added!';

          if (cartType === 'page') {
            window.location = '/cart';
          }

          setTimeout(() => {
            button.textContent = 'Add to cart';
            button.disabled = false;
          }, 2000);
        } else {
          throw new Error(result.error || 'Failed to add to cart');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        button.textContent = 'Add to cart';
        button.disabled = false;
      }
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["social"] && !Shopify.designMode) return;
  try {
    class SocialAccordion {
    constructor(social) {
      this.social = social
      this.collapse = social.dataset.collapse
      this.trigger = social.querySelector('[data-social-trigger]')
      this.panel = social.querySelector('[data-social-panel]')
      if (!this.trigger || !this.panel) return
      this.open = this.trigger.classList.contains('social__trigger--open')
      this.resizeTimer = null

      this.trigger.addEventListener('click', () => this.toggle())
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer)
        this.resizeTimer = setTimeout(() => this.applyState(), 150)
      })

      this.applyState()
    }

    isActive() {
      if (this.collapse === 'social--accordion') return true
      if (this.collapse === 'social--accordion-mobile') return window.matchMedia('(max-width: 767px)').matches
      if (this.collapse === 'social--accordion-desktop') return window.matchMedia('(min-width: 768px)').matches
      return false
    }

    applyState() {
      const active = this.isActive()
      this.social.classList.toggle('social--accordion-active', active)

      if (!active) {
        this.panel.style.maxHeight = ''
        this.trigger.setAttribute('aria-expanded', 'true')
        return
      }

      this.trigger.classList.toggle('social__trigger--open', this.open)
      this.trigger.setAttribute('aria-expanded', this.open ? 'true' : 'false')
      this.panel.style.maxHeight = this.open ? this.panel.scrollHeight + 'px' : '0px'
    }

    toggle() {
      this.open = !this.open
      this.applyState()
    }
  }

  document.querySelectorAll('[data-social]').forEach((el) => {
    if (el.dataset.collapse && el.dataset.collapse !== 'social--list') {
      new SocialAccordion(el)
    }
  })
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trust-points"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-trustpoint-trigger]').forEach((trigger) => {
    const modal = document.getElementById(trigger.dataset.trustpointTrigger);
    if (!modal) return;

    trigger.addEventListener('click', () => modal.showModal());

    modal.querySelector('.trust-points__modal-close').addEventListener('click', () => modal.close());

    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.close();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
